/* unplugin-vue-components disabled */import { render } from "./ButtonBasic.vue?vue&type=template&id=80e2a3e8&scoped=true"
import script from "./ButtonBasic.vue?vue&type=script&lang=js"
export * from "./ButtonBasic.vue?vue&type=script&lang=js"

import "./ButtonBasic.vue?vue&type=style&index=0&id=80e2a3e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e2a3e8"]])

export default __exports__